<!--
 Created by Xuz on 2019/03/25.
 xuz[at]live[dot]cn
 模块配置
-->
<template>
    <page-view title="模块配置">
        <!-- action -->
        <template slot="action">
            <a-button-group>
                <a-button @click="onAddRootModule"><a-icon type="plus-circle"/>添加根模块</a-button>
                <a-button v-show="selectedModule.id" @click="onAddModule"><a-icon type="plus-circle"/>添加子模块</a-button>
                <a-button v-show="selectedModule.id" @click="onEditModule"><a-icon type="edit"/>修改模块</a-button>
                <a-popconfirm title="是否确认删除模块?" @confirm="onDeleteModule">
                    <a-button v-show="selectedModule.id" type="danger"><a-icon type="delete"/>删除模块</a-button>
                </a-popconfirm>
            </a-button-group>
        </template>
        <a-card :bordered="false">
            <a-row class="tree-container">
                <a-col :xxl="4" :xl="6">
                    <a-tree showIcon :expandedKeys="treeExpandedKeys" :loadedKeys="treeLoadedKeys" :treeData="treeData" @expand="onTreeExpand" :loadData="onTreeLoadData" @select="onTreeSelect">
                      <template slot="customIcon" slot-scope="{dataRef}">
                        <a-icon :type="dataRef.icon" />
                      </template>
                    </a-tree>
                </a-col>
                <a-col :xxl="20" :xl="18">
                    <a-skeleton :loading="moduleLoading">
                        <table width="100%" class="fx-form-view">
                            <tr>
                                <th>模块名称</th>
                                <td>{{selectedModule.name}}</td>
                            </tr>
                            <tr>
                                <th>文档类别</th>
                                <td><span>{{selectedModule.extras.cate ? selectedModule.extras.cate.name : ''}}</span></td>
                            </tr>
                            <tr>
                                <th>模块图标</th>
                                <td><a-icon :type="selectedModule.icon" /></td>
                            </tr>
                            <tr>
                                <th>访问路径</th>
                                <td>{{selectedModule.webPath}}</td>
                            </tr>
                            <tr>
                                <th>模板文件</th>
                                <td>{{selectedModule.viewTemplate}}</td>
                            </tr>
                            <tr>
                              <th>打开方式</th>
                              <td>
                                <a-tag v-if="selectedModule.target === 1" color="red">新开窗口</a-tag>
                                <a-tag v-else>默认</a-tag>
                              </td>
                            </tr>
                            <tr>
                                <th>排序</th>
                                <td>{{selectedModule.sort}}</td>
                            </tr>
                            <tr>
                                <th>是否显示</th>
                                <td>
                                    <a-tag v-if="selectedModule.state === '1'" color="green">显示</a-tag>
                                    <a-tag v-else color="red">隐藏</a-tag>
                                </td>
                            </tr>
                            <tr>
                                <th>访问权限</th>
                                <td>{{selectedModule.extras.permissionSummary}}</td>
                            </tr>
                            <tr>
                                <th>描述</th>
                                <td>{{selectedModule.memo}}</td>
                            </tr>
                        </table>
                    </a-skeleton>
                </a-col>
            </a-row>
        </a-card>

        <!-- 添加模块 -->
        <module-add ref="moduleAdd" @success="onAddModuleSuccess" />
        <!-- / 添加模块 -->
        <!-- 编辑模块 -->
        <module-edit ref="moduleEdit" @success="onEditModuleSuccess" />
        <!-- / 编辑模块 -->
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import qs from 'qs'
import ModuleAdd from './ModuleAdd'
import ModuleEdit from './ModuleEdit'

export default {
  name: 'ModuleIndex',
  components: {
    PageView,
    ModuleAdd,
    ModuleEdit
  },
  created () {
    this.loadModule()
  },
  data () {
    return {
      treeExpandedKeys: [],
      treeLoadedKeys: [],
      treeData: [],
      selectedModule: {
        id: '',
        cateId: '',
        parentId: '',
        icon: '',
        webPath: '',
        sort: '',
        memo: '',
        extras: {
          cate: {
            name: ''
          },
          permissionSummary: ''
        }
      },
      moduleLoading: false
    }
  },
  computed: {
  },
  methods: {
    onReloadPage () {
      this.$router.go(0)
    },
    loadModule () {
      const that = this
      that.$http.get('/api/1/module/get_modules_nocache.json').then(function (resp) {
        that.treeData = that.mapTreeData(resp.result)
        that.getModuleInfo(that.treeData[0].key)
      })
    },
    onTreeExpand (expandedKeys) {
      this.treeExpandedKeys = expandedKeys
    },
    onTreeLoadData (treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }

        const that = this
        that.$http.get('/api/1/module/get_modules_nocache.json?parentId=' + treeNode.dataRef.key).then(function (response) {
          treeNode.dataRef.children = that.mapTreeData(response.result)
          that.treeData = [...that.treeData]
          resolve()
        })
      })
    },
    onTreeSelect (selectedKeys, info) {
      const item = info.node.dataRef
      let expanded = this.treeExpandedKeys.includes(item.key)
      // 如果不是叶子节点，则展开节点（易用性）
      if (!item.isLeaf) {
        if (info.selected) {
          // 点击了节点名称，如果还没展开，则展开
          if (!expanded) {
            this.treeExpandedKeys.push(item.key)
          }
        } else {
          // 取消点击了节点名称，如果已经展开，则移除
          if (expanded) {
            this.treeExpandedKeys = this.treeExpandedKeys.filter(id => id !== item.key)
          }
        }
      }

      if (selectedKeys.length === 0) {
        return
      }
      const id = selectedKeys[0]
      this.getModuleInfo(id)
    },
    getModuleInfo (moduleId) {
      const that = this
      that.moduleLoading = true
      that.$http.get('/api/1/module/get_module.json?id=' + moduleId).then(function (resp) {
        that.selectedModule = resp.result
        that.moduleLoading = false
      })
    },
    onAddRootModule () {
      this.$refs.moduleAdd.preModuleAdd(null)
    },
    onAddModule () {
      this.$refs.moduleAdd.preModuleAdd(this.selectedModule)
    },
    onAddModuleSuccess (parentId) {
      this.reloadTreeNode(parentId)
    },
    onEditModule () {
      this.$refs.moduleEdit.preModuleEdit(this.selectedModule)
    },
    onEditModuleSuccess (parentId, srcParentId) {
      if (parentId === srcParentId) {
        this.reloadTreeNode(parentId)
      } else {
        this.reloadTreeNode(srcParentId)
        this.reloadTreeNode(parentId)
      }
    },
    onDeleteModule () {
      const that = this
      that.$http.post('/api/1/module/delete_module.json', qs.stringify({ id: that.selectedModule.id })).then(function (resp) {
        that.$message.success('删除成功')
        that.reloadTreeNode(resp.result.parentId)
      })
    },
    mapTreeData (list) {
      if (!list) {
        return []
      }
      return list.map(item => {
        return {
          key: item.id,
          title: item.name,
          isLeaf: !item.hasChildren,
          icon: item.icon,
          scopedSlots: { icon: 'customIcon' }
        }
      })
    },
    reloadTreeNode (treeNodeId) {
      this.$http.get('/api/1/module/get_modules_nocache.json?parentId=' + treeNodeId).then(resp => {
        if (treeNodeId) {
          this.replaceTreeNodeChildren(this.treeData, treeNodeId, this.mapTreeData(resp.result))
        } else {
          this.treeData = this.mapTreeData(resp.result)
        }
      })
    },
    replaceTreeNodeChildren (treeData, treeNodeId, children) {
      treeData.forEach(item => {
        if (item.key === treeNodeId) {
          item.isLeaf = children.length === 0
          let loadedKeys = this.getTreeNodeKeys([item], 0)
          this.treeLoadedKeys = this.treeLoadedKeys.filter(key => !loadedKeys.includes(key))
          this.treeExpandedKeys = this.treeExpandedKeys.filter(key => !loadedKeys.includes(key))
          this.$set(item, 'children', children)
          this.$forceUpdate()
        } else {
          if (item.children) {
            this.replaceTreeNodeChildren(item.children, treeNodeId, children)
          }
        }
      })
    },
    getTreeNodeKeys (treeNodes, level) {
      let keys = []
      treeNodes.forEach(node => {
        if (level > 0) {
          keys.push(node.key)
        }
        if (node.children) {
          keys = keys.concat(this.getTreeNodeKeys(node.children, ++level))
        }
      })
      return keys
    }
  }
}
</script>

<style scoped>
</style>
